import { render } from "./MetricDetails.vue?vue&type=template&id=1018fc15&ts=true"
import script from "./MetricDetails.vue?vue&type=script&lang=ts"
export * from "./MetricDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__